import React from 'react';

import styles from './styles/upload-list.module.css';

import InfoBox from '../../common-women/InfoBox';

import {ReactComponent as TrashDark} from '../../../assets/docs-women/trash-dark.svg';
import {ReactComponent as TrashRed} from '../../../assets/docs-women/trash-red.svg';

export default function FileBox({ index, file, removeFile }) {
    const { id, name, size, error } = file;

    return (
        <div className={styles.wrapperFile} key={index} datatype={error ? 'error' : ''}>
            <div className={styles.containerFile}>
                <div className={styles.boxInfo}>
                    <p className={styles.name}>{name}</p>
                    <div>
                        <p className={styles.size}>{size}</p>
                        <p className={styles.error}>{error}</p>
                    </div>
                </div>
                <div onClick={() => removeFile(id)}>{error ? <TrashRed /> : <TrashDark />}</div>
            </div>
            {error === '오류 : 지원하지 않는 이름 형식' && <InfoBox type='DOCS' width='100%' />}
        </div>
    );
}
